import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards a route so only authenticated users (optionally with a specific role)
 * can access it. Otherwise redirects to /login.
 *
 * Usage:
 *   <ProtectedRoute><Shell /></ProtectedRoute>
 *   <ProtectedRoute requiredRole="admin"><Admin /></ProtectedRoute>
 */
export default function ProtectedRoute({ children, requiredRole }) {
  const { user, status } = useAuth();

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f5f5f4]">
        <div className="mono-label text-[#52525b]">ЗАГРУЗКА...</div>
      </div>
    );
  }
  if (status !== "authed") return <Navigate to="/login" replace />;
  if (requiredRole === "admin" && !user?.is_admin) return <Navigate to="/" replace />;

  return children;
}
